import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { AnalysisActionType } from '@modules/analysis/types';
import { AnalysisBanner } from '@modules/common/components/AnalysisBanner';
import { getAnalysisTypeDisplayName } from '@modules/dashboard/helpers';

export const useHandleAnalysisBanner = (actionType: AnalysisActionType) => {
  const useCase = useAnalysisStore(({ useCase }) => useCase);

  const analysisTypeName = getAnalysisTypeDisplayName(useCase);

  if (actionType === AnalysisActionType.SAVE_AS) {
    return (
      <AnalysisBanner>
        This {analysisTypeName} wasn't created by you, edits can be saved as a
        new {analysisTypeName}.
      </AnalysisBanner>
    );
  }

  return null;
};
